export default __webpack_public_path__ + "static/media/f5b62ff2b0a167d70940b4c09ffec3d21581594197392.6bc33cf6.webp";